<template>
  <div ref="container">
    <div class="container" v-if="isLogin" :class="{[theme]: true}" @mousemove.stop="navShowHide">
      <!-- 导航栏 -->
      <div class="nav" :class="navAnimateClass">
        <span class="expiry-time" v-if="expiry!=0">
          授权有效期至：<br>
          <span>{{expiry}}</span>
        </span>
        <div class="theme-btn">
          <ThemeBtn/>
        </div>
        <!-- logo -->
        <div class="logo">
          <img src="../assets/logo.png">
        </div>
        <!-- 导航栏选项 -->
        <ul class="first-nav">
          <li
            v-for="(item, index) in firstNav"
            :key="`first-nav-${item.text}`"
            @click="updateFirstCurrent(index)"
            :class="{ current: firstCurrent === index }"
          >
            <span>
              {{item.text}}
            </span>
          </li>
        </ul>
        <!-- 微信二维码 -->
        <div class="wechat-code">
          <img src="../assets/wechat-code.jpg">
          <p>AI传声</p>
        </div>
      </div>
      <div class="box" :class="boxAnimateClass">
        <!-- 文章列表 -->
        <keep-alive>
          <ArticlesList
            :articlesRef="articlesRef"
            :titlesRef="titlesRef"
            :articleMap="articleMap"
            :currentArticleId="currentArticleId"
            :isEditOld="isEditOld"
            @editOld="editOld"
            @isPopBox="is_PopBox"
          />
        </keep-alive>
        <div class="main">
          <!-- 标题栏 -->
          <div class="h1" :class="titleClass">
            <div class="h1_left">
              <img src="../assets/toNav.png" @click="showNav">
              <div class="edit-menu-fontsize">
                <FontSizeBtn @isPopBox="is_PopBox"/>
              </div>
            </div>
            <div class="h1_title">
              <!-- 文章标题 -->
              <template v-if="secondNav === 'ArticlesList'">
                <template v-if="isEditOld">
                  <div class="edit-title">
                    <input
                      type="text"
                      v-model="articleMap[currentArticleId].title"
                      @input="changeArticle"
                      placeholder="请输入文章标题"
                      maxlength=18
                    >
                  </div>
                </template>
              </template>
              <!-- 语音内容标题 -->
              <template v-else>
                <div class="edit-title">
                  <input
                    type="text"
                    v-model="title"
                    @focus="titleFocus"
                    @blur="titleBlur"
                    placeholder="请输入文章标题"
                    maxlength=18
                  >
                </div>
              </template>
            </div>
            <div class="h1_right">
              <!-- 操作按钮 -->
              <div class="edit-menu-btn">
                <button v-if="secondNav !== 'ArticlesList'" class="edit-menu-btn-save" @click="save">保存文章</button>
                <button v-if="secondNav !== 'ArticlesList'" class="edid-menu-btn-new" @click="newArticle">新建速记</button>
                <button v-if="secondNav === 'ArticlesList' && isEditOld === true" class="edit-menu-btn-cancel" @click="editOldDone">取消编辑</button>
                <button v-if="secondNav === 'ArticlesList' && isEditOld === true" class="edit-menu-btn-cancel" @click="save">保存</button>
              </div>
              <!-- 全屏 -->
              <div class="fullscreen" @click="fullScreen">
                <img src="../assets/fullscreen.png">
              </div>
            </div>
          </div>
          <!-- 内容区 -->
          <div class="edit" :style="{fontSize: fontSize}" :class="editClass">
            <div class="edit-head">
              <!-- 文章内容 -->
              <template v-if="secondNav === 'ArticlesList'">
                <template v-if="isEditOld">
                  <textarea v-model="articleMap[currentArticleId].content" @input="changeArticle"></textarea>
                </template>
              </template>
              <!-- 语音转换内容 -->
              <template v-else>
                <ul class="messages-list" ref="messageListDOM" @scroll="mesScroll" v-show="online">
                  <template v-if="messageList.filter(item => item.content.length).length > 0 || (currentMessage && currentMessage.content)">
                    <MessageItem
                      v-for="(message, i) in messageList"
                      v-if="message.content"
                      :i="i"
                      :message="message"
                      :key="message.blockId"
                      :editTheMessage="editTheMessage"
                      :isCurrent="false"
                      @toEdit="toEdit"
                    />
                    <MessageItem
                      v-if="currentMessage"
                      :message="currentMessage"
                      :key="(currentMessage && currentMessage.blockId) || -1"
                      :isCurrent="true"
                    />
                  </template>
                </ul>
                <!-- 字幕速记提示 断网提示 -->
                <template v-if="!(messageList.filter(item => item.content.length).length > 0 || (currentMessage && currentMessage.content)) || !online">
                  <div class="message-list-tip" v-show="online">
                    <Icon :type="`${theme}-tip`" />
                  </div>
                  <div class="message-list-offline" v-show="!online">
                    <Icon :type="`${theme}-offline`" />
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开始加载页面 -->
    <div v-else class="startPage">
      <img src="../assets/startPage.png" :style="'margin-top: ' + marginTop ">
    </div>
    <!-- 继续速记提示框 -->
    <div class="toBottom" @click="toBottom" contenteditable="false">
      <input disabled value="继续速记">
    </div>
    <!-- 遮罩层 -->
    <div class="layer" v-if="isLayer"></div>
  </div>
</template>

<script>
// socket.io
import VueSocketio from 'vue-socket.io'
import store from '../store/index'
import socketio from 'socket.io-client'
// 依赖的外部类库
import Vue from 'vue'
import {
  mapState,
  mapMutations
} from 'vuex'
// 组件
import ThemeBtn from '../components/ThemeBtn'
import ArticlesList from '../components/ArticlesList'
import MessageItem from '../components/MessageItem'
import FontSizeBtn from '../components/FontSizeBtn'
import Icon from '../components/Icon'
// 模块文件
import {
  UPDATE_USER_INFO,
  UPDATE_UID,
  UPDATE_THEME,
  UPDATE_FONTSIZE,
  UPDATE_TITLE_MAP
} from '../store/mutation-type'
import { getFormattingDate } from '../util/util.js'
export default {
  data () {
    return {
      // 页面初始化
      isLogin: false,
      articlesRef: null,
      titlesRef: null,
      // 一级导航
      firstNav: [
        {
          text: '字幕速记',
          secondNav: null,
          icon: 'shortHand'
        },
        {
          text: '文章列表',
          secondNav: 'ArticlesList',
          icon: 'articlesList'
        }
      ],
      firstCurrent: 0,
      expiry: 0,
      // 编辑区-内容
      // 消息文章
      articleId: '',
      title: '', // 编辑区的标题
      messageList: [], // 已输入完成的消息列表
      currentMessage: null, // 正在输入的消息
      messageNeedSave: false,
      // 旧文章
      isEditOld: false, // 编辑旧文章
      articleMap: {},
      currentArticleId: '',
      // 是否显示导航栏
      isShow_nav: 0,
      // 是否显示标题栏
      isShow_title: 4,
      isShow_edit: 2,
      // 显示遮罩的判断
      isLayer: false,
      // 网络连接bool值
      online: false,
      // 动画计时器
      timeoutFn_nav: null, // 隐藏nav的计时器
      timeoutFn_title: null, // 隐藏title的计时器
      // 语音内容滚动条
      scrollTop: 0, // 当前滚动条高度
      lastScrollTop: 0, // 上次滚动条高度
      // 初始加载图标居中样式
      marginTop: '0px',
      // 判断是否为popBox
      isPopBox: false,
      // 判断是否在编辑文字
      isEditing: false
    }
  },
  components: {
    ThemeBtn,
    ArticlesList,
    MessageItem,
    FontSizeBtn,
    Icon
  },
  computed: {
    ...mapState(['config', 'customToken', 'uid', 'theme', 'fontSize', 'titleMap', 'deltaHeight']), // vuex中获取页面配置,用户token,用户id等
    ...mapState(['connect']),
    secondNav () {
      return this.firstNav[this.firstCurrent].secondNav
    },
    needSave () {
      if (this.articleMap[this.currentArticleId]) {
        return this.articleMap[this.currentArticleId].needSave
      } else {
        return false
      }
    },
    // 内容区动画
    boxAnimateClass () {
      if (this.isShow_nav === 0) { // 初始化页面时隐藏导航栏动画
        return 'boxOpenAnimate'
      } else if (this.isShow_nav === 1) { // 滑动隐藏导航栏
        return 'hideNav_box'
      } else if (this.isShow_nav === 2) { // 滑动显示导航栏
        return 'showNav_box'
      } else if (this.isShow_nav === 3) { // 滑动隐藏文章列表
        return 'hideArticlesList'
      } else if (this.isShow_nav === 4) { // 滑动显示文章列表
        return 'showArticlesList'
      } else if (this.isShow_nav === 5) { // 滑动隐藏导航栏和文章列表
        return 'hideArtAndNav_box'
      } else if (this.isShow_nav === 6) { // 滑动显示导航栏和文章列表
        return 'showArtAndNav_box'
      }
    },
    // 导航栏动画
    navAnimateClass () {
      if (this.isShow_nav === 0) { // 初始化页面时隐藏导航栏动画
        return 'navOpenAnimate'
      } else if (this.isShow_nav === 1) { // 滑动隐藏导航栏
        return 'hideNav'
      } else if (this.isShow_nav === 2) { // 滑动显示导航栏
        return 'showNav'
      } else if (this.isShow_nav === 3) { // 滑动隐藏文章列表
        return 'navLeft0'
      } else if (this.isShow_nav === 4) { // 滑动显示文章列表
        return 'navLeft0'
      } else if (this.isShow_nav === 5) { // 滑动隐藏导航栏和文章列表
        return 'hideArtAndNav_nav'
      } else if (this.isShow_nav === 6) { // 滑动显示导航栏和文章列表
        return 'showArtAndNav_nav'
      }
    },
    // 标题栏动画
    titleClass () {
      if (this.isShow_title === 0) { // 动态显示标题栏
        return 'showH1'
      } else if (this.isShow_title === 1) { // 动态隐藏标题栏
        return 'hideH1'
      } else if (this.isShow_title === 2) { // 静态显示标题栏
        return 'top90'
      } else if (this.isShow_title === 3) { // 静态隐藏标题栏
        return 'top0'
      } else if (this.isShow_title === 4) { // 未出现滚动条时，不执行隐藏标题栏动画
        return ''
      } else if (this.isShow_title === 5) { // 点击文章列表时，固定标题栏
        return ''
      }
    },
    // 内容区动画
    editClass () {
      if (this.isShow_edit === 0) { // 动态向上滑动编辑区
        return 'showH1'
      } else if (this.isShow_edit === 1) { // 动态向下滑动编辑区
        return 'hideH1'
      } else if (this.isShow_edit === 2) { // 静态向上滑动编辑区
        return 'top90'
      } else if (this.isShow_edit === 3) { // 静态向下滑动编辑区
        return 'top0'
      }
    }
  },
  watch: {
    title () {
      // console.log('title')
      this.messageNeedSave = true
    },
    async firstCurrent (newVal) {
      if (this.firstCurrent === 1) {
        this.isPopBox = true
        this.$tip({ message: '正在获取远端文章' })
        this.$socket.emit('findAll')
        this.$socket.once('findAll', (data) => {
          if (data.code === 0) {
            this.$alert({ message: '获取成功' })
            this.isPopBox = false
          }
        })
        // 显示文章列表
        this.isShow_nav = 4
        this.showLayer(250)
        // 固定标题栏和编辑区
        this.isShow_title = 5
        this.isShow_edit = 2
      } else {
        // 隐藏文章列表
        if (this.isShow_nav === 4 || this.isShow_nav === 6) {
          this.isShow_nav = 3
          this.showLayer(250)
        }
        // 恢复标题栏和编辑区动画样式
        this.isShow_title = 4
        this.isShow_edit = 2
      }
    },
    // 当主页面加载后, 有1秒5的开场动画,用户不能进行操作
    isLogin (newVal) {
      this.showLayer(1500) // 显示一秒五的遮罩层
    },
    connect (newVal) {
      this.online = newVal
      if (newVal) this.isLogin = true
    }
  },
  methods: {
    ...mapMutations({ // vuex中的mutation混合
      updateUserInfo: UPDATE_USER_INFO,
      updateUid: UPDATE_UID,
      updateTheme: UPDATE_THEME,
      updateFontSize: UPDATE_FONTSIZE,
      updateTitleMap: UPDATE_TITLE_MAP
    }),
    async updateFirstCurrent (val) {
      this.firstCurrent = val
    },
    async save () {
      console.log(this.messageNeedSave, this.messageList.length, this.needSave)
      if (this.secondNav === 'ArticlesList' && this.isEditOld && this.needSave) { // 保存老文章编辑区
        // 准备保存内容
        let articleId = this.currentArticleId
        let { title = getFormattingDate(new Date().getTime(), false), content } = this.articleMap[articleId]
        content = content.split(`\n`).join(`\n`)
        // 保存操作
        this.$tip({ message: '保存中' })
        this.$socket.emit('keep', {articleId, title, content})
        let bool = await new Promise((resolve) => {
          this.$socket.once('keep', (data) => {
            // console.log('keep', data)
            if (data.code === 0) {
              resolve(true)
            }
          })
        })
        if (bool) {
          this.articleMap[articleId].needSave = false
          this.$alert({ message: '保存成功', icon: { show: true, type: 'true' } })
        }
      } else if (this.secondNav !== 'ArticlesList' && this.messageNeedSave && this.messageList.length !== 0) { // 保存消息区
        let { articleId, title, messageList } = this
        let content = messageList.map(item => item.content).filter(item => item.length > 0).join(`\n`) // 拼接messageList内容
        title = title || getFormattingDate(new Date().getTime(), false)
        this.$tip({ message: '保存中' })
        // 保存成功
        if (articleId !== '') { // 不是第一次保存这个文章
          // 更新title, content
          this.$socket.emit('keep', {articleId, content, title})
          let bool = await new Promise((resolve) => {
            this.$socket.once('keep', data => {
              // console.log('keep', data)
              if (data.code === 0) {
                resolve(true)
              }
            })
          })
          if (bool) {
            this.messageNeedSave = false
            this.$alert({ message: '保存成功', icon: { show: true, type: 'true' } })
          }
        } else { // 第一次保存
          // 将标题和文章内容上传到云端
          this.$socket.emit('keep', {content, title})
          let data = await new Promise((resolve) => {
            this.$socket.once('keep', data => {
              // console.log('keep', data)
              if (data.code === 0) {
                resolve(data)
              }
            })
          })
          if (data.code === 0) {
            this.articleId = data.data.articleId
            this.messageNeedSave = false
            this.$alert({ message: '保存成功', icon: { show: true, type: 'true' } })
          }
        }
      } else {
        this.$alert({ message: '没有需要保存的内容' })
      }
    },
    async newArticle () {
      if (this.messageNeedSave) { // 如果当前修改需要保存
        // 提示一下
        let tag = await this.$confirm({
          message: '新建文章将自动保存编辑内容',
          btnList: [
            {
              value: true,
              text: '我要新建',
              className: 'btnConfirm'
            },
            {
              value: false,
              text: '继续编辑',
              className: 'btnReject'
            }
          ]
        })
        if (!tag) {
          return
        } else {
          await this.save()
        }
      }
      this.articleId = ''
      this.title = '' // 编辑区的标题
      this.messageList = [] // 已输入完成的消息列表
      Vue.nextTick(() => {
        this.messageNeedSave = false
      })
    },
    editTheMessage (message, i) { // 保存语音内容区段落修改的内容
      this.messageList[i].content = message
      this.messageNeedSave = true
    },
    changeArticle () { // 修改了文章
      this.articleMap[this.currentArticleId].needSave = true
    },
    async editOld (articleId) {
      if (!articleId) {
        this.isEditOld = false
        this.currentArticleId = articleId
        return
      }
      // 获取远端文章存入此map中
      this.$tip({ message: '正在获取远端文章' })
      this.$socket.emit('findOne', {articleId})
      let article = await new Promise((resolve, reject) => {
        this.$socket.once('findOne', (data) => {
          // console.log('findOne', data)
          if (data.code === 0) {
            resolve(data.data)
          }
        })
      })
      this.$alert({ message: '获取成功' })
      this.$set(this.articleMap, articleId, {
        content: article.content,
        title: article.title,
        needSave: false // 是否未保存
      })
      this.currentArticleId = articleId
      this.isEditOld = true
    },
    async editOldDone () {
      if (this.needSave) {
        // 提示你这篇文章还没有保存，取消编辑将撤销所有本地修改
        let flag = await this.$confirm({
          message: `确认取消编辑《${this.articleMap[this.currentArticleId].title}》`,
          btnList: [
            {
              value: true,
              text: '确认取消',
              className: 'btnConfirm'
            },
            {
              value: false,
              text: '继续编辑',
              className: 'btnReject'
            }
          ]
        })
        if (flag) {
          this.articleMap[this.currentArticleId] = null
          this.editOld(this.currentArticleId)
          this.isEditOld = false
        }
      }
    },
    // 全屏函数
    fullScreen (element) {
      element = document.documentElement
      var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
      if (!isFullscreen) { // 进入全屏
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      } else { // 退出全屏
        if (document.exitFullscreen) document.exitFullscreen()
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen()
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen()
      }
    },
    // error函数
    errFn (err) {
      if (err) {
        console.log(err)
        console.log(window.localStorage, window.sessionStorage)
        window.localStorage.clear()
        window.sessionStorage.clear()
        window.alert('页面缓存过期，请重新扫码登录')
        window.location.reload()
      }
    },
    // 标题聚焦时，取消placeholder的值
    titleFocus (e) {
      e.target.placeholder = ''
    },
    // 标题失去焦点时，改变placeholder的值
    titleBlur (e) {
      e.target.placeholder = '请输入文章标题'
    },
    // 点击导航栏图标 显示导航栏
    showNav (e) {
      if (this.timeoutFn_nav) {
        clearTimeout(this.timeoutFn_nav)
        this.timeoutFn_nav = null
      }
      if (this.isShow_nav === 0 || this.isShow_nav === 1) { // 导航栏显示
        this.isShow_nav = 2
      } else if (this.isShow_nav === 2 || this.isShow_nav === 3) { // 导航栏隐藏
        // this.isShow_nav = 1
      } else if (this.isShow_nav === 4 || this.isShow_nav === 6) { // 文章列表隐藏
        // this.isShow_nav = 5
        // this.showLayer(450)
        return
      } else if (this.isShow_nav === 5) { // 导航栏文章列表显示
        this.isShow_nav = 6
        this.showLayer(450)
        return
      }
      this.showLayer(250)
    },
    // 动画过度时遮罩层显示
    showLayer (time, idx) {
      this.isLayer = true
      setTimeout(() => {
        if (idx) { // 当idx存在时 修改标题栏和内容去动画
          this.isShow_title = idx
          if (this.scrollTop === 0 && idx === 3) this.isShow_edit = 3
        }
        this.isLayer = false
      }, time)
    },
    // 导航栏计时器
    navTimeout (idx) {
      if (this.timeoutFn_nav) return
      this.timeoutFn_nav = setTimeout(() => {
        if (this.timeoutFn_nav) {
          clearTimeout(this.timeoutFn_nav)
          this.timeoutFn_nav = null
        }
        this.isShow_nav = idx
        this.showLayer(400)
      }, 300)
    },
    // 标题栏计时器
    titleTimeout (idx) {
      if (this.timeoutFn_title) return
      console.log('标题栏隐藏动画开始倒计时')
      this.timeoutFn_title = setTimeout(() => {
        if (this.timeoutFn_title) {
          clearTimeout(this.timeoutFn_title)
          this.timeoutFn_title = null
        }
        this.isShow_title = idx
        this.showLayer(300, idx + 2)
      }, 300)
    },
    // 全屏鼠标滑动函数 导航栏的显示与否
    navShowHide (e) {
      if (this.isLayer || this.isPopBox) return
      let x = e.clientX
      let y = e.clientY
      // 导航栏的显示、隐藏
      if (this.isShow_nav === 0 || this.isShow_nav === 1) { // 导航栏隐藏时，且在字幕速记界面
        if (x < 10) {
          this.isShow_nav = 2
        }
      } else if (this.isShow_nav === 3) { // 导航栏显示在字幕速记界面
        if (x < 450 && this.firstCurrent === 1) {
          this.navTimeout(4)
        } else if (this.timeoutFn_nav) {
          clearTimeout(this.timeoutFn_nav)
          this.timeoutFn_nav = null
        }
      } else if (this.isShow_nav === 4 || this.isShow_nav === 6) { // 导航栏显示在文章列表时
        if (x > 450) {
          this.navTimeout(3)
        } else if (this.timeoutFn_nav) {
          clearTimeout(this.timeoutFn_nav)
          this.timeoutFn_nav = null
        }
      } else if (this.isShow_nav === 5) { // 导航隐藏时，且在文章列表界面
        if (x < 10) {
          this.isShow_nav = 6
        }
      }
      // 标题栏隐藏时，滑到顶部弹出标题栏
      if ([4, 5].indexOf(this.isShow_title) > -1) return // 在滚动条未出现之前，不隐藏标题栏
      // 鼠标滑动到顶部，弹出标题栏
      if (y < 10 && (this.isShow_title === 1 || this.isShow_title === 3)) {
        this.isShow_title = 0
        this.showLayer(300, 2)
      } else if (this.isShow_title === 2 || this.isShow_title === 0) {
        // 鼠标离开标题栏后，执行关闭标题栏定时器
        if (y > 90 && this.scrollTop !== 0) {
          if (this.timeoutFn_title === null) {
            this.titleTimeout(1)
          }
        } else {
          // 鼠标在标题栏内，清除定时器
          if (this.timeoutFn_title) {
            clearTimeout(this.timeoutFn_title)
            this.timeoutFn_title = null
          }
        }
      }
    },
    // 内容区滚动条函数
    mesScroll (e) {
      if (this.isShow_title === 5 || this.isPopBox) return
      let {scrollTop, clientHeight, scrollHeight} = e.target
      this.scrollTop = scrollTop
      // 标题栏动画
      if (scrollTop > this.lastScrollTop) {
        if ((this.isShow_title === 2 || this.isShow_title === 4) && scrollTop > 100) {
          this.isShow_title = 1
          this.showLayer(300, 3)
        }
      } else if (scrollTop < this.lastScrollTop) {
        if (this.isShow_title === 3 && scrollTop < scrollHeight - clientHeight - 140) {
          this.isShow_title = 0
          this.showLayer(300, 2)
        }
      }
      // 判断是否显示继续速记提示框
      this.slideBot()

      // 内容区动画
      if (scrollTop === 0) {
        this.isShow_edit = 2
        if (this.isShow_title === 3) {
          this.isShow_title = 0
          this.showLayer(300, 2)
        }
      } else {
        if (scrollTop > 100) this.isShow_edit = 3
      }
      this.lastScrollTop = scrollTop
    },
    is_PopBox (bool) { // 判断遮罩层是否存在
      if (this.isPopBox !== bool) this.isPopBox = bool
    },
    // 继续速记提示框的显示隐藏
    slideBot () {
      let messageListDOM = this.$refs.messageListDOM
      let { scrollTop, clientHeight, scrollHeight } = messageListDOM // 当前滚动条高度, 页面高度, 内容高度
      let botEle = this.$el.getElementsByClassName('toBottom')[0]
      if (botEle) {
        if (scrollTop < scrollHeight - clientHeight - 140) { // 显示继续速记提示框
          botEle.style.bottom = '10px'
        } else { // 隐藏继续速记提示框
          botEle.style.bottom = '-40px'
        }
      }
    },
    toEdit (bool) { // 消息区点击段落进入编辑状态
      this.isEditing = bool
    },
    toBottom () { // 回到底部
      let messageListDOM = this.$refs.messageListDOM
      let {clientHeight, scrollHeight} = messageListDOM
      messageListDOM.scrollTop = scrollHeight - clientHeight
    },
    // socket.io
    auth () {
      this.$socket.once('auth', (data) => {
        // console.log('auth:', data)
        if (data.code === 0) {
          this.$socket.emit('shorthandsJoin', {webToken: sessionStorage['webToken']})
        }
      })
    },
    // 移动端退出字幕速记
    quitShorthands () {
      this.$socket.on('quitShorthands', (data) => {
        window.localStorage.clear()
        window.sessionStorage.clear()
        this.$alert({message: '退出登录，返回登录界面！'})
        window.location.reload()
      })
    }
  },
  // 组件诞生时，对接野狗云，绑定message节点信息
  created () {
    // sessionStorage.setItem('token', 'af077679-1ac0-4fff-9169-7750fa829bfa')
    // sessionStorage.setItem('expiry', 1585469274702)
    // sessionStorage.setItem('webToken', 'af077679-1ac0-4fff-9169-7750fa829bfa')
    // token->个人信息, customToken->对接野狗云
    let token = sessionStorage.getItem('token')
    if (!token) {
      this.$router.push('/Login')
    }
    // 判断是否显示授权有效期
    let expiry = sessionStorage.getItem('expiry')
    let deltaTime = (expiry - new Date().getTime()) / (1000 * 60 * 60 * 24)
    if (expiry > 0 && deltaTime <= 60) {
      expiry = new Date(parseInt(expiry)).toLocaleString()
      this.expiry = expiry.slice(0, expiry.lastIndexOf(':'))
    }
    // socket.io
    Vue.use(VueSocketio, socketio(`${this.config.SOCKET_ROOT}?token=${token}&client=web`), store)
    this.$store.$socket = this.$socket
    this.auth()
    this.quitShorthands()

    this.$socket.on('talk', (data) => {
      // console.log('talk:', data)
      if (data.code === 0) {
        let messagesInfo = data.data // 该节点的值
        // 判断一个文本块是否结束
        if (messagesInfo.finished) { // finished为true时，认为文本块已经结束
          this.messageList.push(messagesInfo)
          this.currentMessage = null
          this.messageNeedSave = true
        } else if (messagesInfo.content) {
          // 同步当前正在输入的消息
          this.currentMessage = messagesInfo
          this.messageNeedSave = true
        }
        if (this.$refs.messageListDOM) {
          // 修正滚动条位置
          let messageListDOM = this.$refs.messageListDOM
          let { scrollTop, clientHeight, scrollHeight } = messageListDOM // 当前滚动条高度, 页面高度, 内容高度
          if (scrollTop >= scrollHeight - clientHeight - 140 && !this.isEditing) { // 当前滚动条在底部的时候，渲染更新后要把滚动条拉回底部
            Vue.nextTick()
              .then(() => { // nextTick为下次渲染立即调用，可访问到更新后的dom元素
                messageListDOM.scrollTop = messageListDOM.scrollHeight - messageListDOM.clientHeight
              })
          }
        }
      }
    })

    this.$socket.on('reconnect', () => {
      this.auth()
      this.$store.state.connect = true
    })
  },
  mounted () {
    // 设置加载页的居中样式
    this.marginTop = -(this.deltaHeight + 113) + 'px'
  }
}
</script>

<style scoped="scoped">
.container {
  position: absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
  overflow: hidden;
}
.startPage{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.startPage>img{
  width: 140px;
  position: absolute;
  left: 50%;
  top:50%;
  margin-left: -87px;
  /*margin-top: -113px;*/
}
.layer {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1000;
  position: absolute;
}
.container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  min-width: 700px;
}
/* 标题栏动画*/
@keyframes titleShow {
  0% {
    top: -90px;
  }
  100% {
    top: 0px;
  }
}
@keyframes titleHide {
  0% {
    top: 0px;
  }
  100% {
    top: -90px;
  }
}
@keyframes titleShow_edit {
  0% {
    top: 0px;
  }
  100% {
    top: 90px;
  }
}
@keyframes titleHide_edit {
  0% {
    top: 90px;
  }
  100% {
    top: 0px;
  }
}
.h1 {
  height: 90px;
  transition: transform 0.5s linear 0s;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
}
.h1.showH1 {
  animation-fill-mode: both;
  animation: titleShow 0.3s linear 0s;
}
.h1.hideH1 {
  animation-fill-mode: both;
  animation: titleHide 0.3s linear 0s;
}
.h1.top0 {
  top: -90px;
}
.h1.top90 {
  top: 0px;
}
.h1_left{
  display: flex;
  align-items: center;
  width:340px;
  flex-shrink: 1;
}
.h1_left>*{
  margin-left: 45px;
  cursor: pointer;
}
.h1_left>img{
  width: 24px;
}
.h1_title{
  flex-grow: 2;
}
.h1_right{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  width: 340px;
}
.h1_right .fullscreen{
  margin-right: 45px;
  cursor: pointer;
}
.h1_right .fullscreen>img{
  width: 24px;
}
.edit-title {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.edit-title span {
  position: relative;
  vertical-align: top;
  width: 100%;
}
.edit-title span:after {
  content: '';
  display: block;
  padding-top: 100%;
}
.edit-title input {
  font-size:  28px;
  text-align: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 30px;
}
.box {
  position: absolute;
  /* width: 100%; */
  /* height: 100%; */
  left: -94px;
  left: 180px;
  top:0;
  bottom: 0;
  right: 0;
  transition: left 0.5s linear 0s;
}
.slideArtlist {
  left: 180px;
}
.main {
  width:100%;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}
.nav {
  position: absolute;
  width:180px;
  left: 0;
  top: 0;
  bottom:0;
  background: #444444;
  z-index: 10;
  box-shadow: 5px 0px 3px rgba(0,0,0,0.12);
}
.nav>ul {
  display: inline-block;
}
.nav .logo{
  width: 180px;
  display: flex;
  justify-content: center;
  margin: 30px 0 44px;
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}
.theme-btn {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
}
/*导航栏隐藏动画过渡*/
@keyframes navHidden {
  0%{
    left: 0;
  }
  100%{
    left: -180px;
  }
}
@keyframes boxHidden {
  0% {
    left: 180px;
  }
  100% {
    left: 0;
  }
}
/*导航栏显示动画过渡*/
@keyframes navShow {
  0%{
    left: -180px;
  }
  100%{
    left: 0;
  }
}
@keyframes boxShow {
  0%{
    left: 0;
  }
  100%{
    left: 180px;
  }
}
/*文章列表的动画过渡*/
@keyframes articlesListShow {
  0%{
    left: 180px;
  }
  100%{
    left: 450px;
  }
}
@keyframes articlesListHide {
  0%{
    left: 450px;
  }
  100%{
    left: 180px;
  }
}
/*文章列表和导航栏同步隐藏显示动画过渡*/
@keyframes artAndNavShow_box {
  0% {
    left: 0px;
  }
  100% {
    left: 450px;
  }
}
@keyframes artAndNavHide_box {
  0% {
    left: 450px;
  }
  100% {
    left: 0;
  }
}
@keyframes artAndNavShow_nav {
  0% {
    left: -180px;
  }
  100% {
    left: 0px;
  }
}
@keyframes artAndNavHide_nav {
  0% {
    left: 0px;
  }
  100% {
    left: -180px;
  }
}
/*执行动画样式*/
/* isShow_nav=0 开场动画 */
/* .navOpenAnimate {
  animation: navHidden 0.4s linear 1s;
  animation-fill-mode: both;
} */
/*isShow_nav=0 开场动画*/
/* .boxOpenAnimate {
  animation: boxHidden 0.4s linear 1s;
  animation-fill-mode: both;
} */
.showArticlesList { /*isShow_nav=4 */
  animation: articlesListShow 0.2s linear 0s;
  animation-fill-mode: both;
}
.hideArticlesList { /*isShow_nav=3*/
  animation: articlesListHide 0.2s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=3 || 4*/
.navLeft0 {
  left: 0;
}
/*isShow_nav=2*/
.showNav_box{
  animation: boxShow 0.2s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=1*/
.hideNav_box{
  animation: boxHidden 0.2s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=1*/
.showNav{
  animation: navShow 0.2s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=2*/
.hideNav{
  animation: navHidden 0.2s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=5*/
.hideArtAndNav_box {
  animation: artAndNavHide_box 0.4s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=6*/
.showArtAndNav_box {
  animation: artAndNavShow_box 0.4s linear 0s;
  animation-fill-mode: both;
}
/*isShow_nav=5*/
.hideArtAndNav_nav {
  animation: artAndNavHide_nav 0.15s linear 0.25s;
  animation-fill-mode: both;
}
/*isShow_nav=6*/
.showArtAndNav_nav {
  animation: artAndNavShow_nav 0.2s linear 0s;
  animation-fill-mode: both;
}
/*内容区*/
.edit {
  margin-left: 30px;
  position: absolute;
  top: 90px;
  left:0;
  right:0;
  bottom:0;
}
.edit.showH1 {
  animation-fill-mode: both;
  animation: titleShow_edit 0.3s linear 0s;
}
.edit.hideH1 {
  animation-fill-mode: both;
  animation: titleHide_edit 0.3s linear 0s;
}
.edit.top0 {
  top: 0px;
}
.edit.top90 {
  top: 90px;
}
.messages-list{
  width:100%;
  height:100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.expiry-time {
  display: block;
  position: absolute;
  bottom: 120px;
  margin: 0 auto;
  font-size: 14px;
  width: 146px;
  left: 17px;
  height: 80px;
  text-align: center;
  border-radius: 10px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, .7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #383838;
}
.expiry-time>span{
  display: inline-block;
  width: 85px;
}
.first-nav {
  width: 100%;
  height: 100%;
  float: left;
}
.first-nav li {
  height: 66px;
  font-size: 18px;
  text-align: center;
  line-height: 66px;
  vertical-align: middle;
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  cursor: pointer;
  color: white;
  position: relative;
}
.first-nav li.current {
  background: #ff8466;
}
.first-nav li span {
  display: block;
  height: inherit;
  margin: 0 10px;
  line-height: inherit;
}
/* 微信二维码 */
.wechat-code {
  width: 100%;
  position: absolute;
  box-sizing: border-box;
  padding: 0px 25px;
  top: 50%;
  transform: translate(0, -50%);
}
.wechat-code img {
  width:100%;
}
.wechat-code p {
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  margin-top: 10px;
}
.edit-head {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.message-list-tip {
  position: absolute;
  width: 198px;
  height: 472px;
  left: 50%;
  top: 50%;
  margin-left: -99px;
  margin-top: -236px;
}
.message-list-offline {
  position: absolute;
  width: 450px;
  height: 477px;
  left: 50%;
  top: 50%;
  margin-left: -225px;
  margin-top: -239px;
}
.edit-head textarea {
  width: 100%;
  height: 100%;
  resize: none;
  font-size: inherit;
  display: block;
}
.edit-menu-btn button {
  font-size: inherit;
  width: 86px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  border-radius: 10px;
  color: #ffffff;
  box-sizing: border-box;
  margin-right: 45px;
}
.edit-menu-btn-save {
  background: #ff8466;
}
.edid-menu-btn-new {
  background-color: #ff5e62;
}
.edit-menu-btn .edit-menu-btn-cancel {
  width:auto;
  font-size: 20px;
  margin-left: 70px;
  margin-right: 0 ;
}
.edit-menu-btn .edit-menu-btn-cancel:first-child {
  margin-left: 0;
}
/*继续速记*/
.toBottom {
  background: #ff8466;
  width: 100px;
  height: 30px;
  border-radius: 10px;
  padding-bottom: 10px;
  position: absolute;
  right: 15px;
  z-index: 99999;
  bottom: -40px;
  cursor: pointer;
  transition: all 0.2s linear 0s;
}
.toBottom>input {
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  position: absolute;
  left: 50%;
  top:50%;
  width: 60px;
  height: 30px;
  margin-left: -40px;
  margin-top: -15px;
}
.toBottom:before {
  display: block;
  content: '';
  position: absolute;
  z-index: 99;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
.toBottom:after {
  content: '';
  display: inline-block;
  width:0;
  height:0;
  border:8px solid transparent;
  border-top-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 22px;
  margin-top: -3px;
}
</style>
<style scoped="scoped">
.default .h1{
  background: #ffffff;
}
.default .main {
  background-color: #fcfcfc;
  color: #5f5e5e;
}
.default .edit-head {
  background: #fcfcfc;
}
.default .edit-title input{
  color: #333333;
}
.default .edit-title input::-webkit-input-placeholder {
  color: #777777;
  font-weight: 200;
}
.default .edit-menu-btn-cancel:nth-child(1) {
  color:#f2515d;
}
.default .edit-menu-btn-cancel:nth-child(2) {
  color:#ff8466;
}
.default .edit-head textarea {
  color: #4b4b4b;
}

.dark .h1{
  background: #1b1b1b;
}
.dark .edit-title input {
  color: #ffffff;
}
.dark .edit-title input::-webkit-input-placeholder {
  color: #ffffff;
  font-weight: 200;
}
.dark .main {
  background: #262626;
  color: white;
}
.dark .edit-head {
  background: #262626;
}
.dark .edit-title {
  border-color: #262626;
  color: white;
}
.dark .edit-menu-btn-cancel:nth-child(1) {
  color:#f2515d;
}
.dark .edit-menu-btn-cancel:nth-child(2) {
  color:#ff8466;
}
.dark .edit-head textarea {
  color: #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue